import { createAction } from "redux-actions";

export const MUTE_TOGGLE = "sound/mute/toggle";

export const toggleMute = createAction(MUTE_TOGGLE);



// WEBPACK FOOTER //
// ./src/reducers/sound/actions.js